// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---theme-src-templates-blog-post-js": () => import("/home/gepeto/beemarketingmx/beemarketingmx-dunham/theme/src/templates/blog-post.js" /* webpackChunkName: "component---theme-src-templates-blog-post-js" */),
  "component---theme-src-pages-404-js": () => import("/home/gepeto/beemarketingmx/beemarketingmx-dunham/theme/src/pages/404.js" /* webpackChunkName: "component---theme-src-pages-404-js" */),
  "component---theme-src-pages-blog-js": () => import("/home/gepeto/beemarketingmx/beemarketingmx-dunham/theme/src/pages/blog.js" /* webpackChunkName: "component---theme-src-pages-blog-js" */),
  "component---theme-src-pages-index-js": () => import("/home/gepeto/beemarketingmx/beemarketingmx-dunham/theme/src/pages/index.js" /* webpackChunkName: "component---theme-src-pages-index-js" */)
}

